




























import { Vue, Component } from 'vue-property-decorator'
import QuizAttempt from '../../api/quizAttempt'
import getApi from '@/api'
import { AttemptResultInterface } from '@/interface/BaseInterface'

const quizAttempt: QuizAttempt = getApi('quizAttempt')

@Component
export default class MyAttempt extends Vue {
  data: AttemptResultInterface[] = []

  async init() {
    try {
      this.data = await quizAttempt.list(this.quizId)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  handleViewDetail(attempt: AttemptResultInterface) {
    this.$router.push({ name: 'quizResult', params: { id: this.courseId, quizId: this.quizId, attemptId: attempt._id } })
  }

  handleView(attempt: AttemptResultInterface) {
    this.$emit('view', attempt)
  }

  created() {
    this.init()
  }
}
